'use strict'

var isBN = require('./lib/is-bn')

module.exports = isRat

function isRat(x) {
  return Array.isArray(x) && x.length === 2 && isBN(x[0]) && isBN(x[1])
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/big-rat/is-rat.js
// module id = Di8J
// module chunks = 0